import ApiBase from '../ApiBase';

class CarouselItem extends ApiBase {
    route = '/exhibitors/carousel-items';

    /**
     * @method storeCarouselItem
     * @param {object} data
     * @return {Promise<*>}
     */
    storeCarouselItem = async (data) => {
        return this.post(this.route, data);
    }

    /**
     * @method updateCarouselItem
     * @param {string} id
     * @param {object} data
     * @return {Promise<*>}
     */
    updateCarouselItem = async (id, data) => {
        return this.patch(this.route+'/' +id, data);
    }
}

export default new CarouselItem();
